import type { ReactNode } from 'react';
import { TenantContext, type TenantContextValue } from './context';

export function TenantProvider({
  value,
  children,
}: {
  value: TenantContextValue;
  children: ReactNode;
}) {
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}
